<svg width="231" height="258" viewBox="0 0 231 258" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!--    arrow   -->
  <path
    *ngIf="
      orderStatus === CustomerTrackingStatusEnum.Ordered ||
      orderStatus === CustomerTrackingStatusEnum.OnItsWay ||
      orderStatus === CustomerTrackingStatusEnum.DeliveredToCollectionPoint
    "
    d="M111.355 88.2619C112.075 89.44 113.614 89.8111 114.792 89.091C115.97 88.3708 116.341 86.832 115.621 85.654L111.355 88.2619ZM125.635 58.0069L128.135 57.9985L125.635 58.0069ZM120.096 16.8158C120.406 15.4702 119.566 14.1285 118.221 13.8189L96.2935 8.77405C94.9479 8.46448 93.6062 9.3043 93.2966 10.6499C92.987 11.9954 93.8268 13.3372 95.1724 13.6468L114.663 18.1311L110.179 37.6219C109.869 38.9674 110.709 40.3092 112.055 40.6187C113.4 40.9283 114.742 40.0885 115.052 38.7429L120.096 16.8158ZM115.621 85.654C110.36 77.0484 108.654 70.5951 108.762 65.9974C108.867 61.4876 110.708 58.6571 112.924 57.0254C115.228 55.3289 118.054 54.838 120.184 55.2706C122.317 55.7036 123.131 56.8113 123.135 58.0153L128.135 57.9985C128.12 53.5872 124.705 51.0866 121.179 50.3706C117.651 49.6542 113.39 50.4736 109.96 52.9991C106.442 55.5894 103.903 59.8927 103.763 65.8806C103.625 71.7807 105.809 79.1893 111.355 88.2619L115.621 85.654ZM123.135 58.0153C123.142 60.1652 122.395 61.4443 121.366 62.2535C120.245 63.1346 118.489 63.688 116.177 63.6933C111.53 63.7039 105.639 61.4828 101.41 57.5448C97.2647 53.6849 94.9146 48.3991 96.6147 42.0836C98.3667 35.5751 104.558 27.4055 118.986 18.3744L116.334 14.1361C101.469 23.4402 94.0198 32.4878 91.7866 40.7839C89.5013 49.273 92.821 56.3791 98.0024 61.204C103.1 65.9506 110.193 68.707 116.188 68.6933C119.196 68.6864 122.176 67.9773 124.457 66.1835C126.829 64.3179 128.147 61.5098 128.135 57.9985L123.135 58.0153Z"
    fill="#F1D3D3" />

  <!--    check  -->
  <ng-container *ngIf="orderStatus === CustomerTrackingStatusEnum.Delivered">
    <path
      d="M130.956 89.9478C142.002 89.9478 150.956 80.9935 150.956 69.9478C150.956 58.9021 142.002 49.9478 130.956 49.9478C119.91 49.9478 110.956 58.9021 110.956 69.9478C110.956 80.9935 119.91 89.9478 130.956 89.9478Z"
      [attr.fill]="colors.checkBackgroundColor || '#05DE76'" />
    <path
      d="M122.956 69.9478L128.956 75.9478L138.956 63.9478"
      [attr.stroke]="baseColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </ng-container>

  <!--    cube front face -->
  <path
    d="M176.958 110.655L197.418 192.805L113.313 213.752L92.8522 131.603L176.958 110.655Z"
    [attr.fill]="colors.frontCubeFaceColor" />

  <!--   cube side face    -->
  <path
    d="M78.9414 198.078L113.719 213.997L93.1775 131.521L58.2372 114.95L78.9414 198.078Z"
    [attr.fill]="colors.sideCubeFaceColor" />

  <!-- cube upper face     -->
  <path
    d="M137.37 94.8918L176.956 110.652L93.1758 131.519L58.2356 114.948L137.37 94.8918Z"
    [attr.fill]="colors.topCubeFaceColor" />

  <!-- label   -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M176.293 131.856L175.02 132.173C174.932 131.823 174.577 131.61 174.226 131.697C173.875 131.785 173.661 132.139 173.747 132.49L172.793 132.728L172.793 132.727C172.705 132.375 172.349 132.161 171.998 132.249C171.646 132.337 171.432 132.692 171.52 133.044L171.52 133.045L170.564 133.283C170.476 132.932 170.121 132.718 169.769 132.806C169.418 132.893 169.204 133.249 169.291 133.6L168.336 133.838L168.336 133.837C168.249 133.486 167.893 133.272 167.541 133.359C167.19 133.447 166.976 133.803 167.063 134.154L167.064 134.155L166.11 134.393L166.109 134.391C166.022 134.039 165.666 133.825 165.314 133.913C164.963 134.001 164.749 134.356 164.836 134.708L164.837 134.71L163.882 134.947L163.882 134.947C163.795 134.596 163.439 134.382 163.087 134.469C162.736 134.557 162.522 134.913 162.609 135.264L162.609 135.265L161.656 135.502L161.655 135.502C161.568 135.15 161.212 134.936 160.86 135.024C160.509 135.111 160.295 135.467 160.383 135.819L160.383 135.819L159.427 136.057C159.339 135.707 158.984 135.494 158.633 135.581C158.282 135.668 158.068 136.023 158.155 136.374L157.2 136.612C157.112 136.261 156.757 136.047 156.405 136.135C156.054 136.222 155.84 136.578 155.927 136.929L154.972 137.167C154.884 136.816 154.528 136.602 154.177 136.689C153.826 136.777 153.612 137.132 153.699 137.484L153.063 137.642L152.826 136.69C153.176 136.602 153.39 136.246 153.302 135.895C153.215 135.544 152.86 135.33 152.509 135.417L152.271 134.462L152.271 134.462C152.622 134.374 152.836 134.018 152.749 133.667C152.661 133.315 152.305 133.101 151.954 133.189L151.954 133.189L151.716 132.233C152.066 132.145 152.28 131.789 152.192 131.438C152.105 131.087 151.75 130.873 151.399 130.96L151.161 130.005C151.512 129.918 151.726 129.562 151.638 129.21C151.551 128.859 151.195 128.645 150.844 128.732L150.606 127.778C150.957 127.69 151.171 127.334 151.084 126.983C150.996 126.632 150.64 126.418 150.289 126.505L150.052 125.552C150.402 125.464 150.616 125.109 150.529 124.757C150.441 124.406 150.086 124.192 149.735 124.279L149.575 123.64L150.213 123.482C150.3 123.833 150.656 124.047 151.008 123.959C151.359 123.872 151.573 123.516 151.486 123.165L152.44 122.927L152.44 122.928C152.528 123.279 152.884 123.493 153.235 123.406C153.587 123.318 153.801 122.962 153.713 122.611L153.713 122.61L154.668 122.372L154.668 122.373C154.756 122.724 155.112 122.938 155.463 122.851C155.815 122.763 156.029 122.407 155.941 122.056L155.941 122.055L156.896 121.817L156.896 121.818C156.983 122.17 157.339 122.384 157.691 122.296C158.042 122.209 158.256 121.853 158.169 121.501L158.168 121.5L159.122 121.263C159.21 121.614 159.566 121.828 159.917 121.74C160.269 121.653 160.483 121.297 160.395 120.946L161.35 120.708L161.35 120.71C161.438 121.061 161.794 121.275 162.145 121.188C162.497 121.1 162.711 120.744 162.623 120.393L162.623 120.391L163.576 120.153C163.664 120.504 164.02 120.718 164.371 120.63C164.722 120.543 164.936 120.188 164.849 119.836L165.805 119.598L165.805 119.6C165.893 119.951 166.249 120.165 166.6 120.077C166.952 119.99 167.166 119.634 167.078 119.283L167.078 119.281L168.032 119.044C168.12 119.395 168.476 119.608 168.827 119.521C169.178 119.433 169.392 119.078 169.305 118.727L170.259 118.489C170.347 118.84 170.703 119.053 171.054 118.966C171.405 118.878 171.619 118.523 171.532 118.172L172.806 117.855L172.964 118.491C172.613 118.579 172.399 118.935 172.487 119.286C172.574 119.638 172.93 119.852 173.281 119.764L173.519 120.718L173.518 120.718C173.167 120.805 172.953 121.161 173.04 121.513C173.128 121.864 173.484 122.078 173.835 121.991L173.836 121.991L174.074 122.946L174.073 122.947C173.722 123.034 173.508 123.39 173.595 123.741C173.683 124.093 174.039 124.307 174.39 124.219L174.391 124.219L174.629 125.175L174.628 125.175C174.277 125.263 174.063 125.619 174.151 125.97C174.238 126.322 174.594 126.535 174.946 126.448L174.946 126.448L175.184 127.403C174.832 127.49 174.619 127.846 174.706 128.198C174.794 128.549 175.149 128.763 175.501 128.676L175.738 129.629C175.738 129.629 175.738 129.629 175.738 129.629C175.386 129.717 175.172 130.073 175.26 130.424C175.347 130.776 175.703 130.99 176.055 130.902C176.055 130.902 176.055 130.902 176.055 130.902L176.293 131.856Z"
    fill="white" />

  <!-- sparkles   -->
  <rect
    x="53.668"
    y="66.2871"
    width="9.4066"
    height="9.4066"
    transform="rotate(-58.9858 53.668 66.2871)"
    [attr.fill]="colors.sparklesColor || '#527DE2'" />
  <rect
    x="54.0176"
    y="182.633"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 54.0176 182.633)"
    [attr.fill]="colors.sparklesColor || '#52E283'" />
  <rect
    x="169.824"
    y="18.5723"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 169.824 18.5723)"
    [attr.fill]="colors.sparklesColor || '#E252D4'" />

  <!-- front ribbon    -->
  <path
    d="M140.599 119.673L161.06 201.823L149.679 204.658L129.219 122.508L140.599 119.673Z"
    [attr.fill]="colors.frontRibbonColor" />

  <!--    top side ribbon  -->
  <path
    d="M78.6798 124.745L160.83 104.284L149.671 99.793L68.825 119.929L78.6798 124.745Z"
    [attr.fill]="colors.topRibbonColor" />

  <!--    top front ribbon     -->
  <path
    d="M129.308 122.835L140.887 119.932L106.63 102.57L97.4617 104.982L129.308 122.835Z"
    [attr.fill]="colors.topRibbonColor" />

  <!--    side ribbon  -->
  <path
    d="M78.6839 124.712L68.8291 119.896L89.1244 202.815L98.898 207.305L78.6839 124.712Z"
    [attr.fill]="colors.sideRibbonColor" />

  <!-- right bow   -->
  <path
    d="M140.192 82.6497C128.582 79.47 122.397 96.3426 121.477 104.264C117.377 108.174 112.658 115.481 126.588 113.433C143.999 110.873 149.354 106.078 152.818 100.389C156.282 94.7 149.18 85.1116 140.192 82.6497Z"
    [attr.fill]="colors.bowColor" />

  <!-- right bow inner    -->
  <path
    d="M151.508 97.4555C147.66 94.9915 137.229 94.1307 126.29 110.399C134.78 109.982 147.698 108.767 151.508 97.4555Z"
    [attr.fill]="colors.bowInnerColor" />

  <!--  left bow  -->
  <path
    d="M86.0904 90.5871C96.344 83.0572 108.831 97.368 112.737 104.837C118.262 107.144 125.682 112.57 111.162 115.819C93.0105 119.88 85.9123 117.174 80.3416 112.87C74.7708 108.566 78.1513 96.4173 86.0904 90.5871Z"
    [attr.fill]="colors.bowColor" />

  <!--  left bow inner    -->
  <path
    d="M80.5251 109.478C83.3905 105.591 93.3589 100.795 110.309 112.711C101.772 115.511 88.5644 119.2 80.5251 109.478Z"
    [attr.fill]="colors.bowInnerColor" />

  <!--  bow tie   -->
  <path
    d="M113.04 104.637C114.397 100.905 120.718 100.096 123.116 103.262C125.678 106.645 125.657 109.913 124.554 113.797C122.868 116.826 117.403 117.805 114.477 115.172C112.239 112.444 111.344 109.301 113.04 104.637Z"
    [attr.fill]="colors.bowTieColor" />

  <!-- more sparkles    -->
  <rect
    x="160.523"
    y="76.126"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 160.523 76.126)"
    fill="#FFD466"
    [attr.fill]="colors.sparklesColor || '#FFD466'" />
  <rect
    x="41.6846"
    y="212.517"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 41.6846 212.517)"
    [attr.fill]="colors.sparklesColor || '#343E57'" />
  <rect
    x="128.525"
    y="233.128"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 128.525 233.128)"
    [attr.fill]="colors.sparklesColor || '#FFD466'" />
  <rect
    x="193.332"
    y="104.122"
    width="7.07887"
    height="7.07887"
    transform="rotate(-58.9858 193.332 104.122)"
    [attr.fill]="colors.sparklesColor || '#FF6A61'" />

  <!--    label   -->
  <rect
    x="153.002"
    y="126.036"
    width="6.31297"
    height="0.901853"
    rx="0.450926"
    transform="rotate(-13.9858 153.002 126.036)"
    fill="#D9D9D9" />
  <rect
    x="153.765"
    y="129.1"
    width="16.2334"
    height="0.901853"
    rx="0.450926"
    transform="rotate(-13.9858 153.765 129.1)"
    fill="#D9D9D9" />
  <rect
    x="154.2"
    y="130.852"
    width="16.2334"
    height="0.901853"
    rx="0.450926"
    transform="rotate(-13.9858 154.2 130.852)"
    fill="#D9D9D9" />
</svg>
